import { alpha, styled } from "@mui/material/styles";
import MuiCard from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import { Container } from "@mui/material";

export const RegistrationCard = styled(MuiCard)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  width: "100%",
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: "auto",
  [theme.breakpoints.up("sm")]: {
    maxWidth: "450px",
  },
  boxShadow: theme.palette.baseShadow,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(2),
}));

export const FruitifyStack = styled(Stack)(({ theme }) => ({
  height: "calc((1 - var(--template-frame-height, 0)) * 100dvh)",
  minHeight: "100%",
  padding: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(10),
  },
  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    zIndex: -1,
    inset: 0,
    backgroundColor: theme.palette.background.default,
    backgroundImage: `radial-gradient(circle at 85% 15%, ${alpha(
      theme.palette.secondary.light,
      0.28,
    )}, transparent 28%)`,
    backgroundRepeat: "no-repeat",
  },
}));
export const FruitifyContainer = styled(Container)(({ theme }) => ({
  flexGrow: 1,
  maxWidth: "100% !important",
  minHeight: "100vh",
  padding: theme.spacing(10, 2),
  backgroundColor: theme.palette.background.default,
  backgroundSize: "cover",
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(4, 4),
  },
  "&::before": {
    content: '""',
    display: "block",
    position: "fixed",
    zIndex: -1,
    width: "100vw",
    height: "100vh",
    top: 0,
    left: 0,
    backgroundColor: theme.palette.background.default,
  },
}));
